import { useNavigate, useSearchParams } from 'react-router';
import { useEffect, useRef, useState } from 'react';
import { LoadingSpinner } from '@components/atoms/LoadingSpinner';
import { apiClient } from '@src/api/client';
import { SampleDto, SampleStatus } from '@src/types/types';
import { Paths } from '@src/routes/paths';

export const ClaimSampleView = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const claimCode = searchParams.get('claimCode');
  const [claimResult, setClaimResult] = useState<SampleDto | undefined>(
    undefined,
  );
  const hasMutated = useRef(false);
  const navigate = useNavigate();

  const { mutate } = apiClient.useMutation('post', '/api/sample/claim', {
    onSuccess: (data: SampleDto) => {
      setClaimResult(data);
    },
    onError: (error) => {
      console.error(error);
      navigate(`${Paths.PROFILE}?claimingFailed=true`);
    },
  });

  useEffect(() => {
    if (claimCode && !hasMutated.current) {
      hasMutated.current = true;
      mutate({ body: { code: claimCode } });
    }
  }, [claimCode, mutate, setSearchParams]);

  useEffect(() => {
    if (claimResult !== undefined) {
      if (
        ((claimResult.status as SampleStatus | undefined) ??
          SampleStatus.ACTIVATED) === SampleStatus.ACTIVATED
      ) {
        navigate(`${Paths.SENDER_ADDRESS}/${claimResult.id}`);
        // If we claimed a sample, that was already processed, we redirect to the profile page
      } else {
        navigate(`${Paths.PROFILE}?sampleClaimed=true`);
      }
    }
  }, [claimResult, navigate]);

  return <LoadingSpinner />;
};
